import React from 'react';
import PropTypes from 'prop-types';
import * as Modal from '@fiverr/modal';
import BlockButton from './BlockButton/index.js';
import ModalBody from './ModalBody/index.js';
import '@fiverr/modal/dist/index.css';
import './style.scss';

const ModalWrapper = ({showBlockButton, userId, submitBlockTrigger, userName}) => (
    <Modal.Base trigger={({toggle}) => showBlockButton && <BlockButton togglePopup={toggle}/>}
        header={i18n.t('seller_card.block_user.title')}>
        {({close}) => <ModalBody userId={userId} userName={userName} submitBlockTrigger={submitBlockTrigger} closeModal={close}/>}
    </Modal.Base>
);

ModalWrapper.propTypes = {
    userId: PropTypes.number,
    showBlockButton: PropTypes.bool,
    userName: PropTypes.string,
    submitBlockTrigger: PropTypes.func
};

ModalWrapper.defaultProps = {
    userId: 0,
    userName: '',
    showBlockButton: false
};

export default ModalWrapper;


// WEBPACK FOOTER //
// ./src/components/block_user/ModalWrapper/index.js